import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_SALESGROUP,
  CREATE_SALESGROUP,
  FETCH_SALESGROUP,
  FETCH_SALESGROUP_LIST,
  UPDATE_SALESGROUP,
} from './salesGroup.actions';
import { SalesGroup, SalesGroupState } from './salesGroup.types';

const initialState: SalesGroupState = {
  errorMessage: '',
  item: {} as Readonly<SalesGroup>,
  items: [] as ReadonlyArray<SalesGroup>,
  loading: false,
  totalItems: 0,
};

export default (
  state: SalesGroupState = initialState,
  action: AppAction,
): SalesGroupState => {
  switch (action.type) {
    case REQUEST(FETCH_SALESGROUP_LIST):
    case REQUEST(CREATE_SALESGROUP):
    case REQUEST(FETCH_SALESGROUP):
    case REQUEST(UPDATE_SALESGROUP):
      return { ...state, loading: true };
    case SUCCESS(FETCH_SALESGROUP_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_SALESGROUP_LIST):
    case FAILURE(CREATE_SALESGROUP):
    case FAILURE(FETCH_SALESGROUP):
    case FAILURE(UPDATE_SALESGROUP):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_SALESGROUP):
    case SUCCESS(FETCH_SALESGROUP):
    case SUCCESS(UPDATE_SALESGROUP):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_SALESGROUP:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
